import React, { useState, useEffect } from 'react';
import { Box, Typography, Paper, Button, Chip, IconButton, Tooltip, TextField } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

const API = (url, opts={}) => fetch(url, { ...opts, headers: { Authorization: 'Bearer ' + localStorage.getItem('dashboard_token'), ...(opts.headers||{}) } });

export default function SecurityPage() {
  const [data, setData] = useState({ banned: [], log: [] });
  const [whitelist, setWhitelist] = useState([]);
  const [newIp, setNewIp] = useState('');
  const [loading, setLoading] = useState(true);
  const [confirmIp, setConfirmIp] = useState(null);
  const [loginLogs, setLoginLogs] = useState([]);

  const load = () => {
    API('/api/security/banned').then(r=>r.json()).then(d=>{ setData(d); setLoading(false); });
    API('/api/security/whitelist').then(r=>r.json()).then(setWhitelist);
    API('/api/security/login-logs').then(r=>r.json()).then(setLoginLogs).catch(()=>{});
  };

  useEffect(() => { load(); const t = setInterval(load, 30000); return () => clearInterval(t); }, []);

  const unban = async (ip) => {
    await API('/api/security/unban/'+ip, { method:'POST' });
    setTimeout(load, 1000);
    setConfirmIp(ip);
  };
  const confirmWhitelist = async (yes) => {
    if (yes && confirmIp) {
      await API('/api/security/whitelist/'+confirmIp, { method:'POST' });
      setTimeout(load, 500);
    }
    setConfirmIp(null);
  };

  const addWhitelist = async () => {
    if (!newIp.trim()) return;
    await API('/api/security/whitelist/'+newIp.trim(), { method:'POST' });
    setNewIp(''); load();
  };

  const removeWhitelist = async (ip) => {
    await API('/api/security/whitelist/'+ip, { method:'DELETE' });
    load();
  };

  return (
    <Box>
      <Typography variant="h5" sx={{ color:'#fff', fontWeight:'bold', mb:3 }}>🛡 Безпека</Typography>

      <Paper sx={{ bgcolor:'#1a1a2e', border:'1px solid #f44336', p:3, mb:3 }}>
        <Typography variant="h6" sx={{ color:'#f44336', mb:2 }}>🚫 Заблоковані IP ({data.banned.length})</Typography>
        {data.banned.length === 0 ?
          <Typography sx={{ color:'#555' }}>Немає заблокованих IP</Typography> :
          <Box sx={{ display:'flex', flexWrap:'wrap', gap:1 }}>
            {data.banned.map(ip => (
              <Chip key={ip} label={ip}
                onDelete={() => unban(ip)}
                deleteIcon={<Tooltip title="Розблокувати"><span>🔓</span></Tooltip>}
                sx={{ bgcolor:'rgba(244,67,54,0.2)', color:'#f44' }}/>
            ))}
          </Box>
        }
      </Paper>

      <Paper sx={{ bgcolor:'#1a1a2e', border:'1px solid #4caf50', p:3, mb:3 }}>
        <Typography variant="h6" sx={{ color:'#4caf50', mb:2 }}>✅ Довірені IP (whitelist)</Typography>
        <Box sx={{ display:'flex', gap:1, mb:2 }}>
          <TextField size="small" placeholder="IP адреса (напр. 1.2.3.4)" value={newIp}
            onChange={e=>setNewIp(e.target.value)}
            sx={{ input:{color:'#fff'}, '& .MuiOutlinedInput-notchedOutline':{borderColor:'#555'} }}/>
          <Button variant="contained" onClick={addWhitelist} sx={{ bgcolor:'#4caf50' }}>+ Додати</Button>
        </Box>
        {whitelist.length === 0 ?
          <Typography sx={{ color:'#555' }}>Список порожній</Typography> :
          <Box sx={{ display:'flex', flexWrap:'wrap', gap:1 }}>
            {whitelist.map(ip => (
              <Chip key={ip} label={ip}
                onDelete={() => removeWhitelist(ip)}
                sx={{ bgcolor:'rgba(76,175,80,0.2)', color:'#4caf50' }}/>
            ))}
          </Box>
        }
      </Paper>

      <Paper sx={{ bgcolor:'#1a1a2e', border:'1px solid #333', p:3 }}>
        <Typography variant="h6" sx={{ color:'#aaa', mb:2 }}>📋 Лог подій (останні 20)</Typography>
        {data.log.length === 0 ?
          <Typography sx={{ color:'#555' }}>Немає записів</Typography> :
          <Box sx={{ fontFamily:'monospace', fontSize:11 }}>
            {[...data.log].reverse().map((line, i) => {
              // Конвертуємо UTC час в локальний
              const converted = line.replace(/^(\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2})/, (m) => {
                try { return new Date(m.replace(' ','T')+'Z').toLocaleString('uk-UA'); } catch { return m; }
              });
              return (
              <Typography key={i} variant="caption" sx={{ color: line.includes('Ban') ? '#f44' : '#4caf50', display:'block', mb:0.3 }}>
                {line}
              </Typography>);
            })}
          </Box>
        }
      </Paper>
      <Paper sx={{ bgcolor:'#1a1a2e', border:'1px solid #333', p:3, mt:3 }}>
        <Typography variant="h6" sx={{ color:'#aaa', mb:2 }}>🔑 Логи входів (останні 50)</Typography>
        {loginLogs.length === 0 ?
          <Typography sx={{ color:'#555' }}>Немає записів</Typography> :
          <Box sx={{ fontFamily:'monospace', fontSize:11 }}>
            {loginLogs.map((log, i) => (
              <Box key={i} sx={{ display:'flex', gap:1, mb:0.3, alignItems:'center' }}>
                <Typography variant="caption" sx={{ color: log.success ? '#4caf50' : '#f44', minWidth:20 }}>
                  {log.success ? '✅' : '❌'}
                </Typography>
                <Typography variant="caption" sx={{ color:'#aaa', minWidth:140 }}>
                  {new Date(log.created_at).toLocaleString('uk-UA')}
                </Typography>
                <Typography variant="caption" sx={{ color:'#555', minWidth:120 }}>
                  {log.ip}
                </Typography>
                <Typography variant="caption" sx={{ color:'#777' }}>
                  {log.username}
                </Typography>
              </Box>
            ))}
          </Box>
        }
      </Paper>

      {confirmIp && (
        <Box sx={{ position:'fixed', top:0, left:0, right:0, bottom:0, bgcolor:'rgba(0,0,0,0.7)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:9999 }}>
          <Box sx={{ bgcolor:'#1a1a2e', border:'1px solid #4caf50', p:3, borderRadius:2, maxWidth:350 }}>
            <Typography sx={{ color:'#fff', mb:2 }}>✅ Додати <b>{confirmIp}</b> до довірених IP?</Typography>
            <Box sx={{ display:'flex', gap:1 }}>
              <Button variant="contained" onClick={()=>confirmWhitelist(true)} sx={{ bgcolor:'#4caf50' }}>Так</Button>
              <Button variant="outlined" onClick={()=>confirmWhitelist(false)} sx={{ borderColor:'#555', color:'#aaa' }}>Ні</Button>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
}
